module.exports = __webpack_public_path__ + "img/user-portfolio@2x.5ff0d66.png";